import * as React from 'react';
import {MediciValidationsModalDispatchProps} from '../../types/containers';

class MediciValidationsModalView
    extends React.Component<MediciValidationsModalDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                El correo para el cliente ha sido enviado. Recuerda refrescar esta vista para visualizar el resultado de validación de identidad.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressClose) {
        return <React.Fragment>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressClose}>Aceptar</a></React.Fragment>;
    }

    render() {
        const {onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressClose)}
                </div>
            </div>
        );
    }
}

export default MediciValidationsModalView;
